//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import lbsManager from "@/Manager/03.Sys/LbsManager";

import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import BmMarker from "vue-baidu-map/components/overlays/Marker";
import BmLabel from "vue-baidu-map/components/overlays/Label";

export default {
  components: {
    "baidu-map": BaiduMap,
    "bm-marker": BmMarker,
    "bm-label": BmLabel
  },
  data() {
    return {
      BaiduMapAK: "8QI6NaQGIWgShfHVsG7KAV6t",
      IsMapReady: true,

      CenterGps: {
        lng: 116.404,
        lat: 39.915
      },

      ThisGps: {
        lng: 116.404, 
        lat: 39.915 
      }
    };
  },

  methods: {
    onMapReady({ BMap }) {
      console.log("BMap", BMap);

      this.IsMapReady = true;

      console.log("IsMapReady", this.IsMapReady);
    },

    getIsMapReady() {
      return this.IsMapReady;
    },

    async setGps84(lng, lat) {
      console.log("setGps84--IsMapReady", this.IsMapReady);
      this.$msg.showLoading("正在获取位置");
      var gpsItem = await lbsManager.getGpsItem(lng, lat);
      this.$msg.hideLoading();
      if (gpsItem != null) {
        this.$msg.succ("获取位置成功.");

        this.CenterGps.lng = gpsItem.GpsBd09Lng;
        this.CenterGps.lat = gpsItem.GpsBd09Lat;

        this.ThisGps.lng = gpsItem.GpsBd09Lng;
        this.ThisGps.lat = gpsItem.GpsBd09Lat;
      }
      return gpsItem;
    }
  },
  created() {
    this.controlItem = this.$parent.controlItem;
    console.log(this.controlItem, "controlItem__+_++_++_+_++_+_____________");

    this.ThisGps.lng = this.$parent.controlItem.ControlValue.GpsBd09Lng;
    console.log(this.ThisGps.lng, "lng");
    this.ThisGps.lat = this.$parent.controlItem.ControlValue.GpsBd09Lat;
  }
};
